export default "__VITE_ASSET__Eugm74A2__"